export const ShopActApi = 'wx/shopact/' // 查看
export const ShopActImgApi = 'wx/shopactimg/' // 活动图片
export const ShopActItemApi = 'wx/shopactitem/' // 会员参加的活动
